import { AsyncPipe, NgClass, NgForOf, NgIf, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { FormlySelectModule } from '@ngx-formly/core/select';
import { isObservable, take } from 'rxjs';
import { FormFieldModule } from '../wrapper/form-field/form-field.component';
import { CyTestDirective } from '@portal/directive';
import { PortalFieldTypeConfig } from '@portal/form/data-access';
import { EMPTY_VALUE } from '@core/data-access';

@Component({
  selector: 'portal-form-button',
  standalone: true,
  imports: [NgIf, NgClass, NgStyle, NgForOf, AsyncPipe, FormlyModule, FormlySelectModule, ReactiveFormsModule, CyTestDirective],
  template: `
    <ng-container *ngIf="props.options | formlySelectOptions: field | async as selectOptions">
      <div
        class="field-button-group"
        [ngStyle]="{ display: disabled ? 'none' : null }"
      >
        <div
          *ngFor="let option of selectOptions; let i = index"
          [tabindex]="props.tabindex"
          [portalCyTest]="field.key"
          class="field-button"
          [ngClass]="{ 'field-button-selected': formControl.value === option.value }"
          (click)="onChange(option.value)"
        >
          <input
            type="radio"
            class="field-button-input peer"
            [id]="id + '_' + i"
            [attr.value]="option.value"
            [value]="option.value"
            [formControl]="formControl"
            [formlyAttributes]="field"
          />
          <label
            class="field-button-label"
            [for]="id + '_' + i"
          >
            {{ option.label }}
          </label>
        </div>
      </div>
    </ng-container>
    <div
      *ngIf="disabled"
      class="field-value"
    >
      {{ value || defaultValue }}
    </div>
  `,
  styles: [':host {@apply block;}'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent extends FieldType<PortalFieldTypeConfig> {
  protected readonly defaultValue = EMPTY_VALUE;

  /**
   * Check if form or field is disabled
   * @returns boolean
   * @readonly
   */
  get disabled(): boolean {
    return !!this.options?.formState?.disabled || !!this.props?.disabled;
  }

  get value() {
    if (this.disabled) {
      if (isObservable(this.props.options)) {
        this.props.options?.pipe(take(1)).subscribe(options => {
          const option = options.find(option => option.value === this.formControl.value);
          return option?.label;
        });
      } else {
        const option = this.props.options?.find(option => option.value === this.formControl.value);
        return option?.label;
      }
    }
    return null;
  }

  onChange(value: any): void {
    // console.log('onChange', value, 'FormValue', this.formControl.value);

    // if (this.formControl.value && this.formControl.value !== value) {
    //   console.log('Confirm before overwriting existing value');
    // }

    if (this.formControl.value !== value) {
      this.formControl.markAsDirty();
      this.formControl.patchValue(value);
      this.formControl.markAsTouched();
      // console.log('FormValue updated', this.formControl.value);
    }
  }
}

@NgModule({
  imports: [
    FormFieldModule,
    FormlyModule.forChild({
      types: [{ name: 'button', component: ButtonComponent, wrappers: ['form-field'] }],
    }),
  ],
})
export class FormButtonModule {}
